var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "editFeedbackForm",
          attrs: {
            model: _vm.editFeedbackForm,
            rules: _vm.editFeedbackFormRules,
            "label-width": "120px"
          }
        },
        [
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "用户声音", name: "first" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "主人名", prop: "user_name" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.editFeedbackForm.user_name,
                            callback: function($$v) {
                              _vm.$set(_vm.editFeedbackForm, "user_name", $$v)
                            },
                            expression: "editFeedbackForm.user_name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "猫咪名", prop: "cat_name" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.editFeedbackForm.cat_name,
                            callback: function($$v) {
                              _vm.$set(_vm.editFeedbackForm, "cat_name", $$v)
                            },
                            expression: "editFeedbackForm.cat_name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "猫品种", prop: "tags" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { multiple: "", placeholder: "请选择" },
                            model: {
                              value: _vm.editFeedbackForm.tags,
                              callback: function($$v) {
                                _vm.$set(_vm.editFeedbackForm, "tags", $$v)
                              },
                              expression: "editFeedbackForm.tags"
                            }
                          },
                          _vm._l(_vm.tags, function(tag) {
                            return _c("el-option", {
                              key: tag.id,
                              attrs: { label: tag.tag, value: tag.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "猫年龄", prop: "cat_age" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.editFeedbackForm.cat_age,
                            callback: function($$v) {
                              _vm.$set(_vm.editFeedbackForm, "cat_age", $$v)
                            },
                            expression: "editFeedbackForm.cat_age"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "猫性别", prop: "cat_sex" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "选择性别" },
                            model: {
                              value: _vm.editFeedbackForm.cat_sex,
                              callback: function($$v) {
                                _vm.$set(_vm.editFeedbackForm, "cat_sex", $$v)
                              },
                              expression: "editFeedbackForm.cat_sex"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "公", value: "公" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "母", value: "母" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "猫照片", prop: "img_list" } },
                      [
                        _c(
                          "el-upload",
                          {
                            attrs: {
                              action: "/dev-api/file-upload",
                              "list-type": "picture-card",
                              "file-list": _vm.editFeedbackForm.img_list,
                              "on-success": _vm.onSuccess,
                              "on-remove": _vm.onRemove,
                              "before-upload": _vm.beforeUpload
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "file",
                                fn: function(ref) {
                                  var file = ref.file
                                  return _c("div", {}, [
                                    _c("img", {
                                      staticClass: "cover-img",
                                      attrs: { src: file.url }
                                    })
                                  ])
                                }
                              }
                            ])
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus",
                              attrs: { slot: "default" },
                              slot: "default"
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dialog",
                          {
                            attrs: { visible: _vm.dialogVisible },
                            on: {
                              "update:visible": function($event) {
                                _vm.dialogVisible = $event
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                width: "100%",
                                src: _vm.dialogImageUrl,
                                alt: ""
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.onCancel } }, [_vm._v("关闭")])
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }